export const pages = {
	'boltHome': { id: 'boltHome', page: 'home', getter: () => import(/* webpackChunkName: 'home' */ 'components/bolt/home/home') }
};
export const sections = [
	{ id: 'boltSynopsis', getter: () => import(/* webpackChunkName: "synopsis" */ 'components/bolt/synopsis/synopsis'), component: 'synopsis', parent: 'boltHome' },
	{ id: 'bringAGroup', getter: () => import(/* webpackChunkName: "imageTiles" */ 'components/bolt/imageTiles/imageTiles'), component: 'imageTiles', parent: 'boltHome' },
	{ id: 'partners', getter: () => import(/* webpackChunkName: "toutVertical" */ 'components/bolt/toutVertical/toutVertical'), component: 'toutVertical', parent: 'boltHome' },
	{ id: 'boltWatchMore', getter: () => import(/* webpackChunkName: "watchMore" */ 'components/bolt/watchMore/watchMore'), component: 'watchMore', parent: 'boltHome' }
];
import VideoOverlayLoader from 'components/bolt/videoOverlayLoader/videoOverlayLoader';
export { VideoOverlayLoader };
